import alinePhotoPopup from './popup/photo/aline.jpg';
import paulinePhotoPopup from './popup/photo/pauline.jpg';
import violainePhotoPopup from './popup/photo/violaine.jpg';
import davidPhotoPopup from './popup/photo/david.jpg';
import tomPhotoPopup from './popup/photo/tom.jpg';
import alinePhotoColorisee from './photos/Aline.jpg';
import paulinePhotoColorisee from './photos/Pauline.jpg';
import violainePhotoColorisee from './photos/Violaine.jpg';
import davidPhotoColorisee from './photos/David.jpg';
import tomPhotoColorisee from './photos/Tom.jpg';


export const equipe = [

    {
        nom: "Aline DUBOIS",
        phrase: "La simplicité est la sophistication suprême",
        auteur: "Léonard de Vinci",
        linkedIn: "https://www.linkedin.com/in/aline-dubois-95a0351aa/",
        github: "https://github.com/alinedubois",
        mail: "juillet.aline@gmail.com",
        selecteurCss: 'aline',
        photoPopup: alinePhotoPopup,
        photoColorisee: alinePhotoColorisee
    },

    {
        nom: "David D'AMATO",
        phrase: "Veni, vidi, vici",
        auteur : "Jules César",
        linkedIn: "https://www.linkedin.com/in/david-damato/",
        github: "https://github.com/David-Damato",
        mail: "david76230@gmail.com",
        selecteurCss: "david",
        photoPopup: davidPhotoPopup,
        photoColorisee: davidPhotoColorisee
    },

    {
        nom: "Pauline LABBE",
        phrase: "La plus grande erreur que vous puissiez faire, dans la vie, c'est d'avoir peur de faire des erreurs",
        auteur: "John Fitzgerald Kennedy",
        linkedIn: "https://www.linkedin.com/in/pauline-labb%C3%A9-360436b7/",
        github: "https://github.com/Palabbe",
        mail: "pauline.labbe7@gmail.com",
        selecteurCss: 'pauline',
        photoPopup: paulinePhotoPopup,
        photoColorisee: paulinePhotoColorisee
    },

    {
        nom: "Tom CARPENTIER",
        phrase: "La connaissance parle, mais la sagesse écoute.",
        auteur : "Jimi Hendrix",
        linkedIn: "https://www.linkedin.com/in/tom-carpentier-46ab84120/",
        github: "https://github.com/TomWebd",
        mail: "t.carpentier.19@gmail.com",
        selecteurCss: 'tom',
        photoPopup: tomPhotoPopup,
        photoColorisee: tomPhotoColorisee
    },

    {
        nom: "Violaine ERNOTTE",
        phrase: "La fanfare c'est la vie !",
        auteur: "Violaine Ernotte",
        linkedIn: "https://www.linkedin.com/in/violaine-ernotte/",
        github: "https://github.com/vio9",
        mail: "e.violaine@yahoo.fr",
        selecteurCss: 'violaine',
        photoPopup: violainePhotoPopup,
        photoColorisee: violainePhotoColorisee
    }
]